import { useCallback } from 'react'

import { useActions, useAppSelector } from '../../../store/hooks'
import { editSchedulePageSelector } from '../../../store/slices/editSchedulePage'

export function useEditScheduleGuard(actions) {
    const isFormDirty = useAppSelector(editSchedulePageSelector.isFormDirty)
    const { setPendingAction } = useActions(actions)

    const checkBeforeAction = useCallback((type, payload) => {
        if (isFormDirty) {
            setPendingAction({ type, payload })
            return false
        }

        return true
    }, [isFormDirty, setPendingAction])

    return { checkBeforeAction, isFormDirty }
}
